export default {
  path: 'winter-service/v2/subcontractors',
  name: 'WinterService2Subcontractors',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/SubcontractorsIndex.vue')
}
